import R from 'ramda'

const SEND_TWEET_ACTION_TYPE = 'SEND_TWEET'
const SEND_TWEET_DISPLAY_TYPE = 'Send Tweet'

const isSendTweetWidgetAction = R.propEq('type', SEND_TWEET_ACTION_TYPE)

const convertSendTweetWidgetActionToFormAction = R.applySpec({
  type: R.always(SEND_TWEET_DISPLAY_TYPE),
  message: R.prop('message'),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  isPromotedTweet: R.T
})

export { isSendTweetWidgetAction, convertSendTweetWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/send-tweet.js